import React, { useEffect, useState } from 'react';
import Clock from './tools/Clock';
import { BoxData } from '../../core/models/Box';
import { fetchBoxData } from '../../core/services/boxService';
import AnimatedBounceBack from './cards/AnimatedBounceBack';
import AnimatedBounceLeft from './cards/AnimatedBounceLeft';
import AnimatedBounceRight from './cards/AnimatedBounceRight';

interface HeaderProps {
  formattedDate: string;
  boxId: string;
}

const Header: React.FC<HeaderProps> = ({ formattedDate, boxId }) => {
  const [boxInfo, setBoxInfo] = useState<BoxData | null>(null);
  // Carga datos del box
  useEffect(() => {
    fetchBoxData(boxId).then(setBoxInfo).catch(console.error);
  }, [boxId]);

  return (
    <header className="w-full text-white">
      {/* Vista móvil: logo y fecha en fila, título abajo */}
      <div className="flex flex-row items-center w-full pl-0 pr-2 py-0 md:hidden">
        <div className="flex-1 flex justify-start mt-4">
          <img src="/assets/logo/logo.png" alt="Alarma" className="w-32 h-10" />
        </div>
        <div className="flex-1 flex justify-end mt-2">
          {<Clock formattedDate={formattedDate} />}
        </div>
      </div>
      <div className="w-full mt-4 flex justify-center md:hidden">
        <h1 className="tv-title-wod font-bold mt-2 mb-2">WOD {formattedDate}</h1>
      </div>

      {/* Vista desktop: todo en una fila */}
      <div className="hidden md:flex flex-row w-full items-center pl-0 pr-2 py-0">
        <AnimatedBounceLeft>
          <div className="justify-start mt-2">
            <img src="/assets/logo/logo.png" alt="Alarma" className="w-32 h-10" />
          </div>
        </AnimatedBounceLeft>

        <div className="w-full  flex items-center justify-center mt-2 mb-2 px-4">
          <AnimatedBounceBack duration="1.1s" delay="0.1s">
            <div className="flex flex-col items-end relative pl-12">
              <h1 className="tv-title-main font-bold text-white">
                {boxInfo?.name}
              </h1>

              {/* <h1 className="w-full text-1xl font-bold text-white text-center">{boxInfo?.phone_number}</h1> */}
            </div>
          </AnimatedBounceBack>
        </div>

        <AnimatedBounceRight>
          <Clock formattedDate={formattedDate} />
        </AnimatedBounceRight>
      </div>
    </header>
  );
};

export default Header;
